import PathConstants from "@routes/PathConstantsMain";
import ProjectConstants from "@./projectConstants";
import { Link, useMatch } from 'react-router';
import {
  Container,
  Row,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";

function Footer({ t }) {
  return (
	<footer className="footer">
		<div className="footer_menu">
			<Navbar>
				<Row className="w-100">
						<div className="col-xl-6 col-lg-4 col-md-12 text-center">
							<NavbarBrand className="py-2" href="https://www.brj-berlin.de/" target="_blank" title={t("Zur Webseite des BRJ e. V.")}>© 2024-{(new Date().getFullYear())} {ProjectConstants.COMPANY_NAME}</NavbarBrand>
						</div>
						<Nav className="col-xl-6 col-lg-8 col-md-12 text-center align-self-center justify-content-center d-md-flex d-block">
							<NavItem>
								<NavLink to={PathConstants.UEBER_UNS} tag={Link} active={Boolean(useMatch(PathConstants.UEBER_UNS))}>{t("Über uns")}</NavLink>
							</NavItem>
							<NavItem>
								<NavLink to={PathConstants.KONTAKT} tag={Link} active={Boolean(useMatch(PathConstants.KONTAKT))}>{t("Kontakt")}</NavLink>
							</NavItem>
							<NavItem>
								<NavLink to={PathConstants.IMPRESSUM} tag={Link} active={Boolean(useMatch(PathConstants.IMPRESSUM))}>{t("Impressum")}</NavLink>
							</NavItem>
							<NavItem>
								<NavLink to={PathConstants.DATENSCHUTZ} tag={Link} active={Boolean(useMatch(PathConstants.DATENSCHUTZ))}>{t("Datenschutz")}</NavLink>
							</NavItem>
						</Nav>
				</Row>
			</Navbar>
		</div>
	</footer>
  );
}

export default withTranslation()(Footer);